module.exports = __webpack_public_path__ + "assets/img/fcbmy.e17b8fa0.png";